export const DashboardIcon = (
  <svg xmlns='http://www.w3.org/2000/svg' width='20' height='20' viewBox='0 0 20 20' fill='none'>
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M3.125 3.75C3.125 3.40482 3.40482 3.125 3.75 3.125H8.75C9.09518 3.125 9.375 3.40482 9.375 3.75V8.75C9.375 9.09518 9.09518 9.375 8.75 9.375H3.75C3.40482 9.375 3.125 9.09518 3.125 8.75V3.75ZM4.375 4.375V8.125H8.125V4.375H4.375Z'
      fill='currentColor'
    />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M10.625 3.75C10.625 3.40482 10.9048 3.125 11.25 3.125H16.25C16.5952 3.125 16.875 3.40482 16.875 3.75V8.75C16.875 9.09518 16.5952 9.375 16.25 9.375H11.25C10.9048 9.375 10.625 9.09518 10.625 8.75V3.75ZM11.875 4.375V8.125H15.625V4.375H11.875Z'
      fill='currentColor'
    />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M3.125 11.25C3.125 10.9048 3.40482 10.625 3.75 10.625H8.75C9.09518 10.625 9.375 10.9048 9.375 11.25V16.25C9.375 16.5952 9.09518 16.875 8.75 16.875H3.75C3.40482 16.875 3.125 16.5952 3.125 16.25V11.25ZM4.375 11.875V15.625H8.125V11.875H4.375Z'
      fill='currentColor'
    />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M10.625 11.25C10.625 10.9048 10.9048 10.625 11.25 10.625H16.25C16.5952 10.625 16.875 10.9048 16.875 11.25V16.25C16.875 16.5952 16.5952 16.875 16.25 16.875H11.25C10.9048 16.875 10.625 16.5952 10.625 16.25V11.25ZM11.875 11.875V15.625H15.625V11.875H11.875Z'
      fill='currentColor'
    />
  </svg>
)
